const SESSION_RECORDING_EVENTS = Object.freeze({
  incentiveOfferClick: "surf_incentive_offer_click",
  incentiveContinueClick: "surf_incentive_continue_click",
  incentivePanelClick: "surf_incentive_panel_click",
  signupNoFreeClick: "surf_signup_no_free_click",
  subPopupOpened: "surf_sub_popup_opened",
  subPopupReading: "surf_sub_popup_reading",
  subPopupInteraction: "surf_sub_popup_interaction",
  subPopupEngagementDummy: "surf_sub_popup_engagement_dummy",
  subEntryLoggedIn: "surf_sub_entry_logged_in",
  subEntryAnon: "surf_sub_entry_anon",
  subConfirmationViewed: "surf_sub_confirmation_viewed",
  subCheckoutStarted: "surf_sub_checkout_started",
  subPaymentSuccess: "surf_sub_payment_success",
  forecastSummaryExpand: "surf_forecast_summary_expand",
  forecastSummaryCollapse: "surf_forecast_summary_collapse",
  forecastSummaryClick: "surf_forecast_summary_click",
  forecastSummaryReading: "surf_forecast_summary_reading",
})

export default SESSION_RECORDING_EVENTS
